module.exports = __webpack_public_path__ + "img/fox.f2064d23.png";